import {PuiSimplePopupReferentielField} from "@portnet/ui";
import React from "react";

const AppSimplePopupReferentielField = React.forwardRef((props, ref) => {
  return <PuiSimplePopupReferentielField ref={ref} {...props} />;
});

export default AppSimplePopupReferentielField;
